<template>
  <div v-bind:class="classObject"
  v-on:drop="drop"
  v-on:click="clickSquare"
  v-on:contextmenu="rightClick">
    <Tile v-if="square.droppedTile != null"
    v-bind:droppedTile="square.droppedTile"
    v-bind:draggable="square.justDropped"
    v-bind:roundNumber="roundNumber"
    v-on:open-letter-selection="openLetterSelection"
    v-on:move-to-draw="moveToDraw"
    ></Tile>
    <span
      v-if="displayShape"
      class="shape"
      v-on:click="openSelectShape"
      v-html="shape">
    </span>

    <div v-if="displaySelectShape" class="selectShape">
      <span  v-for="a in alpha"
        v-bind:key="a"
        v-on:click="(event) => selectShape(event, a)"
        v-html="a">
      </span>
    </div>
  </div>
</template>

<script>
import Tile from './Tile.vue';

export default {
  name: 'Square',
  emits: ['tile-dropped', 'open-letter-selection', 'click-square', 'move-to-draw'],
  props: {
    square: {
      type: Object,
      required: true,
    },
    roundNumber: {
      type: Number,
      required: true,
    },
    selected: {
      type: Boolean,
      required: false,
    },
    horizontal: {
      type: Boolean,
      required: false,
    },
    premium: {
      type: Boolean,
      required: false,
    },
  },
  components: { Tile },
  data() {
    return {
      displayArrow: true,
      timeout: undefined,
      shaped: false,
      displaySelectShape: false,
      shape: '<img src="/static/purple-circle.svg" width="20"/>',
      alpha: ['<img src="/static/purple-circle.svg" width="20"/>',
        '<img src="/static/chevron-down.svg" width="20"/>',
        '<img src="/static/chevron-up.svg" width="20"/>',
        '<img src="/static/chevron-right.svg" width="20"/>',
        '<img src="/static/chevron-left.svg" width="20"/>',
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
        'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v',
        'w', 'x', 'y', 'z', '&spades;', '&clubs;', '&hearts;', '&diams;'],
    };
  },
  computed: {
    classObject() {
      const result = {
        square: true,
        'd-flex': true,
        'flex-column': true,
        selected: this.selected,
        'arrow-horizontal': this.selected && this.displayArrow && this.horizontal,
        'arrow-vertical': this.selected && this.displayArrow && !this.horizontal,
        'last-border-right': this.square.column === 14,
        'last-border-bottom': this.square.row === 14,
      };
      result[this.square.squareType] = true;
      return result;
    },
    displayShape() {
      return this.shaped &&
          (!this.selected || !this.displayArrow) &&
          !this.square.droppedTile;
    },
  },
  beforeUnmount() {
    clearTimeout(this.timeout);
  },
  methods: {
    drop(event) {
      event.preventDefault();
      const message = JSON.parse(event.dataTransfer.getData('text/plain'));
      message.to = { square: { ...this.square } };
      this.$emit('tile-dropped', message);
    },
    openLetterSelection(tile) {
      this.$emit('open-letter-selection', tile);
    },
    moveToDraw(tile) {
      this.$emit('move-to-draw', tile);
    },
    clickSquare() {
      if (!this.square.droppedTile || this.square.droppedTile.tile.value !== '?') {
        this.displayArrow = true;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.displayArrow = false;
        }, 2500);
        this.$emit('click-square', this.square);
      }
    },
    rightClick(event) {
      event.preventDefault();
      this.displayArrow = false;
      this.shaped = this.premium && !this.shaped;
    },
    openSelectShape(event) {
      event.preventDefault();
      event.stopPropagation();
      this.displaySelectShape = true;
      this.timeout = setTimeout(() => {
        this.displaySelectShape = false;
      }, 3500);
    },
    selectShape(event, shape) {
      event.preventDefault();
      event.stopPropagation();
      this.shape = shape;
      this.displaySelectShape = false;
    },
  },
};
</script>

<style>
.square{
  background-color: #ffffe8;
  border-left: 1px solid #A3A3A3;
  border-top: 1px solid #A3A3A3;
  position: relative;
}
.square.last-border-right {
  border-right: 1px solid #A3A3A3;
}
.square.last-border-bottom {
  border-bottom: 1px solid #A3A3A3;
}
.square.doubleWord{
  background-color: #f09d9e;
}
.square.tripleWord{
  background-color: #f26d6b;
}
.square.doubleLetter{
  background-color: #c2c2ff;
}
.square.tripleLetter{
  background-color: #5050ff;
}
.square.selected{
  border: 1px solid black;
}
.square .shape {
  position: absolute;
  left: 9px;
  top: 6px;
  line-height: 1.6rem;
  text-align: center;
  color: #CE04CE;
  font-size: 1.6rem;
  text-transform: uppercase;
  font-weight: bold;
}
.square.arrow-horizontal::before,
.square.arrow-vertical::before{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 20px;
  height: 20px;
}
.square.arrow-horizontal::before{
  content: url(/static/a-arrow-right.svg);
}
.square.arrow-vertical::before {
  content: url(/static/a-arrow-down.svg);
}

.selectShape {
  display:block;
  position: absolute;
  left: 20px;
  z-index: 100;
  background-color: #EDFCF7;
  padding: 10px 10px;
  width: 200px;
  overflow-wrap: anywhere;
}

.selectShape *{
  float: left;
  line-height: 1.6rem;
  font-size: 1.6rem;
  cursor: pointer;
  color: #CE04CE;
  margin-right: 2px;
  text-transform: uppercase;
}

@media (min-width: 992px) {
  .square.arrow-horizontal::before,
  .square.arrow-vertical::before{
    top: 4px;
    left: 4px;
    width: 30px;
    height: 30px;
  }
}

</style>
